module.exports = __webpack_public_path__ + "static/media/bancor.9b41de1c.png";